<template>
  <b-modal
    v-model="show"
    size="lg"
    title="Time off report"
    :modal-class="isLoading ? 'common-worked-days-report loading' : 'common-worked-days-report'"
    centered
  >
    <b-card no-body>
      <b-tabs card v-if="Object.values(filteredWorkedDaysReportData).length" v-model="workedDaysTabIndex">
        <b-tab
          class="overflow-auto"
          v-for="yearData in filteredWorkedDaysReportData"
          :key="yearData.year"
          :title="yearData.year + ''">
          <WorkedDaysReportTable
              :year="yearData.year"
              :reportData="yearData.year_items"
              :workingDaysInYear="yearData.working_days_count"
              @dataUpdated="dataUpdated"
          />
        </b-tab>
        <div class="select-employment-type">
          <multiselect
            v-model="employmentType"
            :options="employmentSelect"
            :placeholder="'Select'"
            :track-by="'value'"
            :label="'label'"
            :allow-empty="false"
            :showLabels="false"
          />
        </div>
      </b-tabs>
    </b-card>
    <template v-slot:modal-footer><span /></template>
  </b-modal>
</template>

<script>
import { cloneDeep } from 'lodash'
import WorkedDaysReportTable from '@components/tables/WorkedDaysReportTable.vue'
export default {
  name: 'CommonWorkedDaysReportModal',
  components: {
    WorkedDaysReportTable
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    workedDaysReportData: {
      type: Array,
      default () {
        return []
      }
    },
    value: {
      type: Boolean
    }
  },
  data () {
    return {
      workedDaysTabIndex: 0,
      employmentSelect: [
        { value: 'all', label: 'All empl. types' },
        { value: 'team_member', label: 'Team member' },
        { value: 'independent', label: 'Independent' },
        { value: 'partner', label: 'Partner' }
      ],
      employmentType: { value: 'team_member', label: 'Team member' }
    }
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    filteredWorkedDaysReportData () {
      const workedDaysReportData = cloneDeep(this.workedDaysReportData)
      if (this.employmentType && this.employmentType.value !== 'all') {
        const currentEmploymetType = this.employmentType.value
        for (let yearKey in workedDaysReportData) {
          for (let userKey in workedDaysReportData[yearKey].year_items) {
            if (workedDaysReportData[yearKey].year_items[userKey].user.employment_type.type !== currentEmploymetType) {
              delete workedDaysReportData[yearKey].year_items[userKey]
            }
          }
          workedDaysReportData[yearKey].year_items = workedDaysReportData[yearKey].year_items.filter(function (item) {
            return item !== undefined
          })
        }
      }
      return workedDaysReportData
    }
  },
  methods: {
    dataUpdated () {
      this.$emit('dataUpdated')
    }
  }
}
</script>
